import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1038px;
  width: 100%;
  margin-top: 3%;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 16px;
  border-radius: 10px;
  margin: 10px 0;
`;
export const InlineContainer = styled.div`
  display: flex;
  margin-left: 6px;
  gap: 16px;
  div {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const DateContainer = styled.div`
  display: flex;
  height: 47;
`;
export const ComboDatePicker = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 3px;

  p {
    margin: 15px;
  }
`;

export const ContButton = styled.div`
  margin-top: 10px;
  padding: 5px;
  display: flex;
  gap: 16px;
`;
export const LabelDate = styled.label`
  text-align: left;
  font: 300 15px Calibri;
  letter-spacing: 0.52px;
  opacity: 1;
  margin: 5px;

  & > div {
    height: 47px;
  }
`;
